<template>
  <VeeField
    v-if="useCartFormData().value.invoiceAddress != null"
    v-slot="{ field, meta }"
    v-model="useCartFormData().value.invoiceAddress!.company"
    name="companyName"
    rules="required|max:50"
  >
    <div :class="meta.touched ? (meta.valid ? 'valid' : 'invalid') : ''">
      <input
        v-bind="field"
        :class="inputClass"
        type="text"
        placeholder="Firmenname*"
        maxlength="50"
      >
    </div>
  </VeeField>
  <VeeErrorMessage name="companyName" />
</template>
<script lang="ts" setup>
import { useCartFormData } from "~/composables/states";
type InputClass = string;

defineProps({
  inputClass: {
    type: String as PropType<InputClass>,
    default: "inp sm",
  },
});
</script>
